import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import componentServices from '../componentServices';
import { Confirm, Expander, FileList} from './sharedComponents';
import * as fileActions from '../fileActions';
import { getCollection, ModelCollection } from 'Scripts/store';
const ContractFileContainer = ({ jobCost, files, uploadFiles, deleteFile }) => {
	const fileLists = [<FileList key={jobCost.key} title="Contract Files" emptyTitle = "No Files" relatedType="jobcost" relatedTypeKey={ jobCost.key } list={ _.filter(files, { relatedType: 'jobcost', relatedTypeKey: jobCost.key }) } uploadFiles={ uploadFiles } deleteFile={ deleteFile } />];

	_.forEach(_.sortBy(jobCost.changeOrders, 'relayId'), co => {
		fileLists.push(<FileList key={co.key} title={ `Change Order - ${co.name}` } emptyTitle = "No Files" subTitle={ co.relayNumber } relatedType="change" relatedTypeKey={ co.key } list={ _.filter(files, { relatedType: 'change', relatedTypeKey: co.key }) } uploadFiles={ uploadFiles } deleteFile={ deleteFile } />);
	});

	return (<Expander title={ `CONTRACT - ${jobCost.name}` } subTitle={ jobCost.relayNumber }>
		{ fileLists }
	</Expander>);
};

const EstimatesFileContainer = ({ jobCosts, files, uploadFiles, deleteFile, title }) => {
	const titleSection = "Estimates";
	const fileLists = _.map(jobCosts, jobCost => {
		return <FileList key={jobCost.key} emptyTitle= {`No ${title}`} title={ jobCost.name } subTitle={ jobCost.relayNumber } relatedType="jobcost" relatedTypeKey={ jobCost.key } list={ _.filter(files, { relatedType: 'jobcost', relatedTypeKey: jobCost.key }) } uploadFiles={ uploadFiles } deleteFile={ deleteFile } />;
	});

	return (<Expander title= {titleSection}>
		{ fileLists }
	</Expander>);
};

export default class JobFilesEdit extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(this.props);

		this.uploadFiles = this.uploadFiles.bind(this);
		this.deleteFile = this.deleteFile.bind(this);
		this.handleFileChange = this.handleFileChange.bind(this);
	}

	componentDidMount () {
		fileActions.fetchFilesForJob({ job: this.props.job });
	}
	UNSAFE_componentWillReceiveProps (nextProps) {
		this.setState(this.getStateFromProps(nextProps));
	}

	getStateFromProps (props) {
		const { store } = componentServices;
		const { job } = props;
		const state = _.assign({ detachedFiles: [], relatedTypeKeys: {}}, this.state);

		if (job !== state.job) {
			const jobCosts = getCollection({ store, collection: ModelCollection.jobCosts});
			const groups:any[] = [];

			if (jobCosts && jobCosts.size) {
				jobCosts
					.filter(jc => jc.jobKey === job.key)
					.forEach(jc => {
						const sortStatus = jc.getMostRecentStatusByStatus('approved') || jc.getMostRecentStatusByStatus('pending-approval');
						const sortDate = sortStatus ? sortStatus.dateCreated : jc.dateCreated;

						const group = {
							sortDate: sortDate,
							model: jc,
							sortPriority: jc.type === 'contract' ? 0 : 1
						};

						state.relatedTypeKeys[jc.key] = 'jobcost';

						_.forEach(jc.changeOrders, co => {
							state.relatedTypeKeys[co.key] = 'change';
						});

						groups.push(group);
					});
			}

			state.groups = _.orderBy(groups, ['sortPriority', 'sortDate'], ['asc', 'desc']);
		}

		state.jobFiles = getCollection({ store, collection: ModelCollection.files}).filter(f => {
			return f.rootKey === job.key && (f.group === 'documents' || f.group === 'files');
		}).toArray();

		state.detatchedFiles = _.filter(state.jobFiles, f => f.relatedTypeKey && !state.relatedTypeKeys[f.relatedTypeKey]);

		return state;
	}

	updateModel (updater, options) {
		this.props.updateModel(model => {
			updater(model);
		}, options);
	}

	uploadFiles (files, relatedType?, relatedTypeKey?) {
		_.forEach(files, f => {
			fileActions.enqueueUpload({ rootKey: this.props.job.key, rootType: 'job', file: f, relatedType: relatedType, relatedTypeKey: relatedTypeKey });
		});
	}

	deleteFile (file) {
		const deleter = () => {
			fileActions.deleteFile({ file: file });
			actions.popModal();
		};
		const title = `Delete ${file.name}?`;

		actions.pushModal({
			component: <Confirm title={title} message="Are you sure you want to delete this file?" confirmLabel="Yes" cancelLabel="No" cancelHandler={ actions.popModal } confirmHandler={ deleter } />
		});
	}

	handleFileChange (e) {
		e.preventDefault();

		this.uploadFiles(e.target.files);
	}

	render () {
		const { job, title } = this.props;
		const { groups, jobFiles, detatchedFiles } = this.state;
		const titleSection = "Files";

		const containers = _.map(_.filter(groups, { sortPriority: 0 }), g => {
			return <ContractFileContainer key={g.model.key} jobCost={ g.model } files={ jobFiles } uploadFiles={ this.uploadFiles } deleteFile={ this.deleteFile } />;
		});

		if (containers.length < groups.length) {
			const jobCosts = _.map(_.filter(groups, { sortPriority: 1 }), g => g.model);

			containers.push(<EstimatesFileContainer title={title} key="estimates" jobCosts={ jobCosts } files={ jobFiles } uploadFiles={ this.uploadFiles } deleteFile={ this.deleteFile } />);
		}

		const jobActions = [<div key="jobUpload" className="button iconLabel upload">
			<span>Upload</span>
			<input type="file" onChange={this.handleFileChange} multiple={ true } />
		</div>];

		return (<React.Fragment>
			<Expander title = {titleSection} actions={ jobActions }>
				<FileList emptyTitle = {`No ${title}`} key={job.key} list={ detatchedFiles } deleteFile={ this.deleteFile } />
			</Expander>
			{ containers }
		</React.Fragment>);
	}
}